import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { MarketDataProvider } from '../context/MarketDataContext';

export default function Layout() {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <MarketDataProvider>
      <div className="min-h-screen min-h-[100dvh] bg-gray-50">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 pb-20 sm:pb-8">
          <Outlet />
        </main>
      </div>
    </MarketDataProvider>
  );
}
